const React = require('react');

const Facebook = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M13.5519 8.05758H11.3044V6.58356C11.3044 6.02999 11.6713 5.90093 11.9297 5.90093C12.1876 5.90093 13.5158 5.90093 13.5158 5.90093V3.46736L11.3315 3.45883C8.90673 3.45883 8.35493 5.27387 8.35493 6.43539V8.05758H6.95264V10.5652H8.35493C8.35493 13.7834 8.35493 17.6611 8.35493 17.6611H11.3044C11.3044 17.6611 11.3044 13.7452 11.3044 10.5652H13.2947L13.5519 8.05758Z" fill="#405992" />
  </svg>
);

module.exports = Facebook;
